import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MoveableTable from './MoveableTable';
import axios from 'axios';
import api from '../../config.json'
import swal from 'sweetalert';

const CheckpointConfig = ({ history, Heading }) => {
    const [reportData, setReportData] = useState({})
    const [types, setAllTypes] = useState([])
    const location = useLocation()
    useEffect(() => {
        GetAllInspetcionTypes()
        if (location.state && location.state.action == 'update') {
            setReportData(location.state.data)
        } else {
            setReportData({ Columns: [{}] })
        }
    }, [location])
    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    useEffect(() => {
        Heading('Configure Checkpoint')
    }, [])

    const handleOnChange = (e) => {
        const obj = { ...reportData }
        const { name, value } = e.target;
        obj[name] = value
        setReportData(obj)
    }

    const handleSave = () => {
        const columns = [...reportData.Columns];
        const errMsg = "Standard Dimension, (+) Tolerance and (-) Tolerance Data Types are required";
        const deciesionInput = columns.filter(x => x.DataType == "UserInputDecision")
        const isDmensionType = columns.find(x => ["StandardDimension", "Dimension+Tolerance", "Dimension-Tolerance"].includes(x.DataType))
        if (isDmensionType) {
            const standard = columns.filter(x => x.DataType == "StandardDimension")
            if (standard.length == 0 || standard.length > 1) {
                swal(errMsg, { dangerMode: true });
                return
            }
            const plusTolerance = columns.filter(x => x.DataType == "Dimension+Tolerance")
            if (plusTolerance.length == 0 || plusTolerance.length > 1) {
                swal(errMsg, { dangerMode: true });
                return
            }
            const minusTolerance = columns.filter(x => x.DataType == "Dimension-Tolerance")
            if (minusTolerance.length == 0 || minusTolerance.length > 1) {
                swal(errMsg, { dangerMode: true });
                return
            }
        }

        if (deciesionInput.length == 0 || deciesionInput.length > 1) {
            swal("One UserInputDecision Data Type is mandatory", { dangerMode: true });
            return
        }
        if (location.state.action == 'update') {
            axios.patch(api.api + `checkPointConfig/${reportData._id}`, reportData)
                .then((result) => {
                    swal('Data Saved Successfully');
                    history.push('/setting/checkpoint_config/list')
                })
                .catch((err) => {
                    swal(`${err}`);
                })
        } else {
            axios.post(api.api + "checkPointConfig", reportData)
                .then((result) => {
                    swal('Data Saved Successfully');
                    history.push('/setting/checkpoint_config/list')
                })
                .catch((err) => {
                    swal(`${err}`);
                })
        }

    }

    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'checkPointConfig')
            .then((result) => {
                const reports = [...reportType]
                result.data.forEach((one) => {
                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType }
                    reports.push(obj)
                })
                setAllTypes(reports)
            })
            .catch((err) => {
                console.log(err);
            })
    }
    return (
        <>
            {/* <div className='text-center'>
              
                <p>Configure Checkpoint</p>
            </div> */}
            <MoveableTable reportData={reportData} handleOnChange={handleOnChange} reportTypes={types} />
            <div className='text-center'>
                <button onClick={handleSave} className='btn-sm btn-primary'>Save</button>
                <button onClick={() => history.push('/setting/checkpoint_config/list')} className='btn-sm btn-primary ml-2'>Cancel</button>
            </div>
        </>
    );
}

export default CheckpointConfig;